import Icon, { IconName } from '../design/Icon';
import { splitTime } from '../design/atoms';

/* One row of the calendar feed. Ported from the mobile app's AgendaRow: a ruled
   time column, the title block, and a trailing tag (or a sage tick when the
   day is already logged). Style values come from member.css only. */

export type AgendaKind = 'book' | 'plan' | 'rest' | 'done' | 'log';

const TAGS: Record<AgendaKind, { label: string; cls: string } | null> = {
  book: { label: 'Booked', cls: 'tag' },
  plan: { label: 'Planned', cls: 'tag gold' },
  rest: { label: 'Rest', cls: 'tag gold' },
  log: { label: 'Log', cls: 'tag gold' },
  done: null, // renders the tick instead
};

export default function AgendaRow({
  kind,
  time,
  title,
  sub,
  icon,
  dimmed,
  onClick,
}: {
  kind: AgendaKind;
  /** "HH:MM", or null for anytime items. */
  time: string | null;
  title: string;
  sub?: string;
  icon?: IconName;
  dimmed?: boolean;
  onClick: () => void;
}) {
  const t = time ? splitTime(time) : null;
  const tag = TAGS[kind];

  return (
    <button
      className="slot"
      style={{
        opacity: dimmed ? 0.55 : 1,
        ...(kind === 'plan' || kind === 'log'
          ? { background: 'linear-gradient(180deg, var(--tint1), var(--tint2))', borderColor: 'var(--gold-line)' }
          : kind === 'rest'
            ? { background: 'transparent', boxShadow: 'none', border: '1.5px dashed var(--line-2)' }
            : {}),
      }}
      onClick={onClick}
    >
      <div className="t">
        <span className="num" style={{ fontSize: 14 }}>{t ? t.time : 'Any'}</span>
        <span className="tiny">{t ? t.ampm : 'TIME'}</span>
      </div>
      <div className="col" style={{ gap: 1, flex: 1, minWidth: 0 }}>
        <div className="row" style={{ gap: 6, minWidth: 0 }}>
          {icon && <Icon n={icon} s={14} c="var(--ink-2)" />}
          <div className="mid trunc">{title}</div>
        </div>
        {sub && <div className="tiny trunc">{sub}</div>}
      </div>
      {kind === 'done' ? (
        <span
          style={{
            width: 22, height: 22, borderRadius: 100, background: 'var(--sage)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 22px',
          }}
        >
          <Icon n="check" s={13} c="#fff" w={2.2} />
        </span>
      ) : tag ? (
        <span className={tag.cls}>{tag.label}</span>
      ) : null}
      <Icon n="right" s={16} c="var(--ink-3)" />
    </button>
  );
}
